import axios from "axios";
import React, {Component} from "react";
import { Helmet } from 'react-helmet';
import FeatherIcon from "feather-icons-react";
import Schoolfee_ from "./Schoolfee_";

class  Schoolfee extends Component{

    state = {
        loading : false,
        schoolfeecategory : {
            category : ""
        }
    }
    
    componentDidMount(){
        this.getSchoolfeecategory();
    }

    componentDidUpdate(previousProps){
        if(previousProps.match.params.schoolfeecategory_id !== this.props.match.params.schoolfeecategory_id){
            this.getSchoolfeecategory();
        }
    }

    async getSchoolfeecategory(){
        this.setState({loading : false});
        var schoolfeecategory = await axios.get('schoolfeecategories/' +this.props.match.params.schoolfeecategory_id);
        if(schoolfeecategory.status == 200)
        {
            this.setState({schoolfeecategory : schoolfeecategory.data, loading : true}) 
        }
    }
    
    render(){
        const sectionItems = this.state.schoolfeecategory?.sectionschoolfeecategories || [];
        var sections =  "", sections_ = []

        sectionItems.forEach((sec)=>{
            if(sec.transport?.id){
                const transportKey = "transport-" + sec.transport.id;
                if(sections_.filter(v => v.key == transportKey)?.length == 0)
                    sections_.push({key : transportKey, id : sec.transport.id, type : "transport", entitled_section : sec.transport.axe, short_entitled_section : '' })
            }
            else if(sec.section?.id){
                const sectionKey = "section-" + sec.section.id;
                if(sections_.filter(v => v.key == sectionKey)?.length == 0)
                    sections_.push({key : sectionKey, id : sec.section.id, type : "section", short_entitled_section : sec.section.short_entitled_section, entitled_section : sec.section.entitled_section })
            }
        })

        const classCount = sections_.reduce((total, section) => {
            const relatedItems = sectionItems.filter(data => section.type === "transport" ? data.transport?.id == section.id : data.section?.id == section.id && !data.transport);
            return total + relatedItems.reduce((sum, item) => sum + (item.transport ? 1 : (item.section?.sectionclasses?.length || 0)), 0);
        }, 0);

        sections = sections_.map(section =>(
            <section className="schoolfee-category-section ev-page-section" key={ section?.key}>
                <div className="schoolfee-category-section__header">
                    <span><FeatherIcon icon={section.short_entitled_section ? "layers" : "truck"} size={18} /></span>
                    <div>
                        <small>{section.short_entitled_section ? section.short_entitled_section : "Transport"}</small>
                        <h2>{section.entitled_section}</h2>
                    </div>
                </div>
                <div className="schoolfee-category-section__body">
                    {
                        sectionItems.filter(data => section.type === "transport" ? data.transport?.id == section?.id : data.section?.id == section?.id && !data.transport)?.map((sect)=>(
                            sect.transport ? <Schoolfee_ trans={1} schoolfeecategory={this.state.schoolfeecategory.id} schoolfeecategory_={ this.state.schoolfeecategory } key={sect.id} id={ sect.transport?.id } name={ sect.transport?.axe } /> :
                                sect.section?.sectionclasses?.sort((a, b) => a.class?.short_entitled_class > b.class?.short_entitled_class ? 1 : -1).map(sectionclass =>{
                                    return ( <Schoolfee_ trans={0} schoolfeecategory={this.state.schoolfeecategory.id} schoolfeecategory_={ this.state.schoolfeecategory } key={sectionclass.id} id={ sectionclass?.id } name={ sectionclass.class?.short_entitled_class + ' ' + sectionclass.title +' - ' + sect.section?.short_entitled_section + ' - '+ sect?.price + ' ' + sect?.currency }  /> )
                                })
                        ))
                    }
                </div>
            </section>
        ))
            
        return(
            <div className="schoolfee-category-page ev-page">
                <Helmet>
                    <title>{ process.env.REACT_APP_NAME } | students paiements { this.state.schoolfeecategory.category}</title>
                </Helmet>

                <header className="ev-page-header schoolfee-category-header">
                    <div className="ev-page-header__content">
                        <span className="ev-page-header__eyebrow">Comptabilite scolaire</span>
                        <h1>Liste des paiements { this.state.schoolfeecategory?.category}</h1>
                        <p>Selectionnez une classe ou un axe de transport pour consulter les recus et ajouter un paiement.</p>
                    </div>
                    <div className="ev-page-header__actions schoolfee-category-stats">
                        <span><FeatherIcon icon="grid" size={16} /> {sections_.length} section(s)</span>
                        <span><FeatherIcon icon="users" size={16} /> {classCount} groupe(s)</span>
                    </div>
                </header>

                <div className="schoolfee-category-grid">
                    {
                        this.state.loading ? (sections_.length > 0 ? sections : (
                            <div className="schoolfee-category-state">
                                <FeatherIcon icon="inbox" />
                                <span>Aucun groupe de paiement pour cette categorie.</span>
                            </div>
                        )) : (
                            <div className="schoolfee-category-state">
                                <FeatherIcon className="user-search-spin" icon="loader" />
                                <span>Chargement des paiements...</span>
                            </div>
                        )
                    }
                </div>
            </div>
        )
    }
}
export default Schoolfee;
